import { clsx } from "clsx";
import { Skeleton } from "../Skeleton";
import { useTableContext } from "./context";
import { TableCell } from "./TableCell";

type Props = {
  className?: string;
};

export function TableLoadingRow({ className }: Props) {
  const { columns, selection, gridTemplateColumns } = useTableContext();

  return (
    <div
      className={clsx("nuco-table__loading-row", className)}
      style={{ gridTemplateColumns }}
      role="row"
    >
      {selection && (
        <div className="nuco-table__loading-row__selection" role="gridcell">
          <Skeleton width="1.25rem" height="1.25rem" />
        </div>
      )}
      {columns.map((column) => {
        return (
          <TableCell key={column.key} align={column.align}>
            <Skeleton width="100%" height="1.25rem" />
          </TableCell>
        );
      })}
    </div>
  );
}
